import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "linkshul_token";

export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}
export function setToken(t) {
  if (t) localStorage.setItem(TOKEN_KEY, t);
  else localStorage.removeItem(TOKEN_KEY);
}

const client = axios.create({ baseURL: API });
client.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export function formatApiError(err) {
  const d = err?.response?.data?.detail;
  if (d == null) return err?.message || "Something went wrong.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (d && typeof d === "object") return d.message || d.error || JSON.stringify(d);
  return String(d);
}

// Special helper: returns { error_code } for structured errors like pending_approval / must_change_password
export function extractErrorCode(err) {
  const d = err?.response?.data?.detail;
  if (d && typeof d === "object" && d.error) return d.error;
  return null;
}

export const apiGet = (path) => client.get(path).then((r) => r.data);
export const apiPost = (path, body) => client.post(path, body).then((r) => r.data);
export const apiPut = (path, body) => client.put(path, body).then((r) => r.data);
export const apiDelete = (path) => client.delete(path).then((r) => r.data);
export async function apiDownload(path, filename) {
  const r = await client.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(r.data);
  const a = document.createElement("a");
  a.href = url; a.download = filename; document.body.appendChild(a); a.click(); a.remove();
  URL.revokeObjectURL(url);
}

export const streamAI = async ({ sessionId, message, onDelta, onSessionId, onDone, onError }) => {
  try {
    const res = await fetch(`${API}/ai/chat`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...(getToken() ? { Authorization: `Bearer ${getToken()}` } : {}),
      },
      body: JSON.stringify({ session_id: sessionId, message }),
    });
    if (!res.ok || !res.body) {
      let msg = `AI request failed (${res.status})`;
      try { const d = await res.json(); msg = (d?.detail?.message || d?.detail || msg); if (typeof msg !== "string") msg = JSON.stringify(msg); } catch {}
      onError && onError(msg);
      return;
    }
    const reader = res.body.getReader();
    const decoder = new TextDecoder();
    let buffer = "";
    while (true) {
      const { value, done } = await reader.read();
      if (done) break;
      buffer += decoder.decode(value, { stream: true });
      const parts = buffer.split("\n\n");
      buffer = parts.pop() || "";
      for (const part of parts) {
        const line = part.trim();
        if (!line.startsWith("data:")) continue;
        const payload = line.slice(5).trim();
        if (payload === "[DONE]") { onDone && onDone(); return; }
        try {
          const data = JSON.parse(payload);
          if (data.session_id) onSessionId && onSessionId(data.session_id);
          if (data.delta) onDelta && onDelta(data.delta);
          if (data.error) onError && onError(data.error);
        } catch {}
      }
    }
    onDone && onDone();
  } catch (e) {
    onError && onError(String(e));
  }
};
